import React, { useEffect,useState } from "react";
import { useNavigate } from "react-router-dom";
import "./OtpStyles.css";
import { BsPlayCircle } from "react-icons/bs";
import "./CustomerFormStyle.css";
import ReactPlayer from 'react-player/lazy';
import { CloseOutlined } from "@ant-design/icons/lib/icons";
import { Modal } from "antd";
import VideoContainer from "./VideoContainer";

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

const WatchVideo = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const { height, width } = useWindowDimensions();
  const {
    videoTitle,
    videoId,
    eventName,
    name,
    currentScreen=4, 
    thumbnail
  } = props;

  const hideModal = (e) => {
    e.stopPropagation();
    setIsModalVisible(false);
  }


  return (
    <div
    style={{
      // border:"1px solid blue",
      width:"100%"
    }}
    >
      {currentScreen < 3 ? (
        <VideoContainer
          videoTitle={videoTitle}
          setIsModalVisible={setIsModalVisible}
          thumbnail={thumbnail}
        />
      ) : (
        <button
          onClick={() => {
            setIsModalVisible(true);
            window?.Moengage?.track_event(eventName);
          }}
          className="WatchVideo"
          style={{
            backgroundColor: "transparent",
            borderColor: "transparent",
            padding: 0,
          }}
        >
          <BsPlayCircle className="videoLogo" />
          <p className="videoText" style={{ marginBottom: 0 }}>
            {" "}
            {name ? name : "Watch video"}
          </p>
        </button>
      )}
      <div className="vertical-video-modal" style={{ bottom: 0, width: width }}>
        <Modal
          visible={isModalVisible}
          centered={true}
          closable={true}
          footer={null}
          // keyboard={true}
          mask={true}
          maskClosable={true}
          onCancel={false}
          closeIcon={
            <CloseOutlined
              onClick={hideModal}
              className="modalCloseBtn"
              style={{ fontWeight: "bold" }}
            />
          }
          className="modal"
          style={{
            bottom: 0,
            verticalAlign: "bottom",
            padding: 0,
            margin: 0,
            width: width - 100,
          }}
        >
          <p
            style={{ textAlign: "center", fontWeight: "500", color: "#6c63ff" }}
          >
            {videoTitle}
          </p>
          <ReactPlayer
            url={`https://www.youtube.com/watch?v=${videoId}`}
            controls={true}
            width="100%"
            className="react-player"
            // height = "100%"
            height={height - 90}
            style={{ marginTop: 20 }}
          />
        </Modal>
      </div>
    </div>
  );
};

export default WatchVideo;
